import { SubmitToSandboxSamplesFormController } from '../controller/SubmitToSandboxSamplesFormController';
import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { Observable } from 'rxjs';

export class SubmitToSandboxSamplesFormWebComponent extends BaseWebComponentElement {
  public controller!: SubmitToSandboxSamplesFormController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: SubmitToSandboxSamplesFormController,
    });
  }

  public getFormValue(): string[] {
    return this.controller.view.dom.$inputGrid.getFormValue() ?? [];
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.dom.$inputGridFormField?.valid$;
  }
}
